export default __webpack_public_path__ + "static/media/close.14c3801b.svg";